import * as globalVars from 'settings/globalVars';
import * as httpHolder from 'services/apis/jasper/httpHolder';


/**
 * 0 - definisce la sessionid che verrà usato per l'autenticazione con Jasper Report Services
 */
export function createSessionId() {
    return Math.random().toString(36).slice(2);
}

/**
 * 1 - registra la sessionid  nei servizi di Jasper in modo da avere l'autenticazione
 */
export function registerToken(sessionId) {
    if (!sessionId) throw new Error("Argument 'jasperAuthenticationHolder.sessionId' is null");

    var url = globalVars.getCalAmpBaseUri() + 'reporting/registertoken/' + globalVars.getJasperConnect() + '/' + sessionId

    return httpHolder.getInstance().get(url, {withCredentials: true});
}

export function getJasperOptions(accountId) {
    if (!accountId) throw new Error("Argument 'accountId' is null");
    if (accountId <= 0) throw new Error("Argument 'accountId' is not valid");

    var url = globalVars.getCalAmpBaseUri() + 'reporting/jasperOptions?accountId=' + accountId;

    return httpHolder.getInstance().get(url, {withCredentials: true});
}

export function getLoginSuccess() {


}


// WEBPACK FOOTER //
// ./src/services/apis/jasper/jasperReportService.js